import http from "./httpService";

export function renewAccountWithCredit(accountId, { quantity = 1 } = {}) {
  return http.post(`/client/accounts/${accountId}/renew-with-credit`, { quantity });
}

export function startRenewalPayment(accountId, { quantity = 1, creditAmount = 0, providerKey = '' } = {}) {
  return http.post(`/client/accounts/${accountId}/renew-payment`, { quantity, creditAmount, providerKey });
}

export function setAccountAutoRenew(accountId, enabled) {
  return http.patch(`/client/accounts/${accountId}/auto-renew`, { enabled: !!enabled });
}

export function getWallet() {
  return http.get("/client/wallet");
}

export function getServiceChangeContext(accountId) {
  return http.get(`/client/accounts/${accountId}/service-change`);
}

export function requestServiceChange(accountId, body) {
  return http.post(`/client/accounts/${accountId}/service-change`, body);
}

export function cancelServiceChange(accountId, changeId) {
  return http.post(`/client/accounts/${accountId}/service-change/${changeId}/cancel`, {});
}
